module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('ul', {
    staticClass: "account-list list-box"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": _vm.basePath,
      "exact": ""
    }
  }, [_vm._v("个人资料")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/social")
    }
  }, [_vm._v("社交通讯")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/identity")
    }
  }, [_vm._v("身份认证")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/privacy")
    }
  }, [_vm._v("隐私设置")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/security")
    }
  }, [_vm._v("安全设置")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/log")
    }
  }, [_vm._v("登录日志")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": (_vm.basePath + "/unbind")
    }
  }, [_vm._v("注销账号")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c76fbabe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/personal_profile.vue
// module id = MsLM
// module chunks = 15